import { Box, styled } from '@mui/material'

// Global UI
import { TypographyH2, TypographyH3, TypographyP } from '@/ui'

export const OurServicesH2 = styled(TypographyH2)(({ theme }) => ({
  fontWeight: 300,
  fontSize: theme.typography.pxToRem(44),
  lineHeight: 1.08,
  color: '#372d2b',
  textTransform: 'capitalize',

  '& .firstHeadline': {
    fontSize: theme.typography.pxToRem(44),
    fontWeight: 300,
    lineHeight: '1.04em',
    textAlign: 'center',
  },
  '& .secondHeadline': {
    fontSize: theme.typography.pxToRem(44),
    fontWeight: 'bold',
    lineHeight: '1.04em',
    textAlign: 'center',
  },
}))

export const ServiceDataDiv = styled(Box)(({ theme }) => ({
  marginBottom: theme.typography.pxToRem(50),
}))

export const CardMedDiv = styled(Box)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  borderRadius: theme.typography.pxToRem(3),
  transition: 'all 3s ease',

  '& img.MuiCardMedia-root': {
    height: theme.typography.pxToRem(350),
    objectFit: 'cover',
    objectPosition: 'center center',
    transition: 'all 3s ease',

    '&:hover': {
      transform: 'scale(1.1)',
      transformOrigin: 'center center',
      borderRadius: theme.typography.pxToRem(3),
    },
  },
}))

export const ServicesNameH3 = styled(TypographyH3)(({ theme }) => ({
  color: '#303043',
  fontSize: theme.typography.pxToRem(24),
  fontWeight: 700,
  lineHeight: '1.67em',
  margin: 0,
  padding: 0,
  maxBlockSize: 0,
}))

export const ServiceDescP = styled(TypographyP)(({ theme }) => ({
  fontWeight: 300,
  fontSize: theme.typography.pxToRem(14),
  lineHeight: 1.6,
  color: '#372d2b',
}))
